

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEEMPLOYEEEVALUATION= createAsyncThunk(
  "updateEmployeeEvaluation/updateEmployeeEvaluation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateEmployeeEvaluationSlice = createSlice({
  name: "updateEmployeeEvaluationSlice",
  initialState: {
    updateEmployeeEvaluation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateEmployeeEvaluation: (state) => {
        state.updateEmployeeEvaluation.loading = false
        state.updateEmployeeEvaluation.error = false
        state.updateEmployeeEvaluation.data = []
        state.updateEmployeeEvaluation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEEMPLOYEEEVALUATION.fulfilled, (state, action) => {
      state.updateEmployeeEvaluation = {
        ...state.updateEmployeeEvaluation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEMPLOYEEEVALUATION.pending, (state, action) => {
      state.updateEmployeeEvaluation = {
        ...state.updateEmployeeEvaluation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEMPLOYEEEVALUATION.rejected, (state, action) => {
      state.updateEmployeeEvaluation = {
        ...state.updateEmployeeEvaluation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateEmployeeEvaluationAction = {
    UPDATEEMPLOYEEEVALUATION,
};

export { updateEmployeeEvaluationAction };
export default updateEmployeeEvaluationSlice.reducer;
export const {setInitialStateOfupdateEmployeeEvaluation} = updateEmployeeEvaluationSlice.actions
